// extracted by mini-css-extract-plugin
export default {"buttons":"LogoutModal_buttons__97Xxv"};